import Vue from 'vue'

// 全站共用的 function，會注入每個 component 當中
Vue.mixin({
  methods: {
    /**
     *  字串加密 https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/atob
     * encodeURIComponent: 處理中轉英以及特殊字元像是 '@' 的編碼
     * btoa: base64編碼
     */
    encodeValue (value) {
      if (!value) return false
      return window.btoa(encodeURIComponent(value))
    },
    // 將 /n 改成 <br> 換行顯示
    lineBreak (str) {
      return str ? str.replace(/\n|\r\n/g, '<br/>') : ''
    },
    // 標註千分位
    formatComma (str) {
      return str ? str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : str
    },
    roundNumber (value, count = 2) {
      return (value).toFixed(count)
    },
    downloadFile (fileName, res) {
      const a = document.createElement('a')
      document.body.appendChild(a)
      const blob = new Blob([res], {type: 'octet/stream'})
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = `${fileName}`
      a.click()
      window.URL.revokeObjectURL(url)
    }
  }
})



// WEBPACK FOOTER //
// ./src/utils/mixins.js